import {
  inject,
  observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IFacilityStore,
} from '../../mobx-store/storeInterfaces/facilitiesInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import { AuthStore } from '../../mobx-store/stores/authStore';
import queryString from 'query-string'
import GeneralSearchComponent from '../../components/GeneralCRUDComponent/GeneralSearchComponent/GeneralSearchComponent';
import { languageCodes } from '../../constants/languages';

interface IProps extends WithSnackbarProps {
  facilityStore: IFacilityStore;
  countryStore: CountryStore;
  authStore: AuthStore;
  match: any;
  history: any;
  location: any;
}

interface IState {
  facilityType: any;
  searchQuery: string;

}

export enum facilityTypes {
  MARKETING = "MARKETING",
  RATING = "RATING",
  ALL = "all",
}

@inject('facilityStore')
@inject('countryStore')
@inject('authStore')
@observer
class Facilities extends Component<IProps, IState> {
  addButton: any;

  tableHeader: any = [];

  tableData: any = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string = translate('facilitiesListPageTitle', {
  });

  constructor(props: IProps) {
    super(props);
  }

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.facilityStore.updateFacilityStatus(index, value)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/facilities/${this.props.facilityStore.facilitiesList[index].facilityId}/edit?type=${this.state.facilityType}`);
  };

  handleGenerateQRClicked = async (index: number, key: string) => {
    try {

      if (!this.props.facilityStore.facilitiesList[index]) {
        SnackBarComponent.getInstance().openSnackbar(
          'Error generating QR : Facility doesn\'t exist',
          3000,
          'error'
        );
        return;
      }
      alert(`You can generate QR code from AppsFlyer dashboard. id: ${this.props.facilityStore.facilitiesList[index].FacilityGroupId}`)

    } catch(error) {
      console.log(error);
    }
  }

  handelAdd = (): void => {
    this.props.history.push(`/facilities/new?type=${this.state.facilityType}`);
  };

  handleEditForm = (index: number, key: string): void => {
    localStorage.setItem('parentRoute', '/facilities?type=RATING');
    this.props.history.push({
      pathname: `/facilities-form/${this.props.facilityStore.facilitiesList[index].questionsForm}/edit`,
    });
  };

  getAddBranchButton = () => ({
    title: 'Add',
    onAdd: this.handelAdd,
  });

  getFacilityTableHeader = () => {
    const headers = [
      {
        title: translate('facilitiesListFacilityColumnTitle', {
        }),
      },
      {
        title: translate('facilitiesListBranchColumnTitle', {
        }),
      },
      {
        title: translate('facilitiesListStatusColumnTitle', {
        }),
      },
      {
        title: translate('facilitiesListEditColumnTitle', {
        }),
      }
    ];

    const facilityType = this.getQueryParam();
    if (facilityType === facilityTypes.RATING) {
      headers.push(
      {
        title: 'Edit Form',
      });
      headers.push(
        {
        title: translate('facilitiesListGenerateColumnTitle', {
        }),
      });
    }

    return headers;
  }

  getFacilityTableCellTypes = (): TableCellTypes[] => {
    const cellTypes: TableCellTypes[] = [
      {
        cellType: 'Text',
        key: 'name',
      },
      {
        cellType: 'Text',
        key: 'branchTitle',
      },
      {
        cellType: 'ToggleButton',
        key: 'isActive',
        activeLabel: translate('FacilityPageFormActiveLabel', {
        }),
        inactiveLabel: translate('FacilityPageFormNotActiveLabel', {
        }),
        onChange: this.handleTableToggleCellChange,
      },
      {
        cellType: 'Button',
        key: 'edit',
        onClick: this.handleTableButtonCellClicked,
      },
    ];

    const facilityType = this.getQueryParam();
    if (facilityType === facilityTypes.RATING) {
      cellTypes.push({
        cellType: 'Button',
        key: 'editForm',
        onClick: this.handleEditForm,
      });
      cellTypes.push({
        cellType: 'Button',
        key: 'generate',
        onClick: this.handleGenerateQRClicked,
      });
    }

    return cellTypes;
  }

  getTableData() {
    return this.props.facilityStore.facilitiesList;
  }
  
  initTable = () => {
    this.addButton = this.getAddBranchButton();
    this.tableHeader = this.getFacilityTableHeader();
    this.tableCellTypes = this.getFacilityTableCellTypes();
    this.tableData = this.getTableData();
  };

  asyncSetState = async<K extends keyof IState>(state: Pick<IState, K>) => new Promise((res) => {
    this.setState({
      ...state,
    }, () => res());
  });

  handleSearchChanged = async (searchQuery: string) => {
    const {
      countryStore, facilityStore,
    } = this.props;
    const queryValues = queryString.parse(this.props.location.search);
    const facilityTypeToCall: any = (queryValues.type) ? queryValues.type : facilityTypes.ALL;
    await this.asyncSetState({
      searchQuery,
      facilityType: facilityTypeToCall,
    });

    await countryStore.getUserManagedCountries();

    if (searchQuery.length === 0) {
      await facilityStore.getFacilities(countryStore.managedCountries, facilityTypeToCall, "", languageCodes.english);
    } else {
      await facilityStore.getFacilities(countryStore.managedCountries, facilityTypeToCall, searchQuery, languageCodes.english);
    }
  };

  render() {
    this.initTable();
    return (
      <div>
        <div>
          <GeneralSearchComponent
            onSearchClick={this.handleSearchChanged}
            searchBy="title"
          />
        </div>
        <GeneralTableComponent
          emptyMessage={translate('facilitiesListNoFacilitiesMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.facilityStore.getFacilitiesRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }

  getQueryParam = () => {
    const queryValues = queryString.parse(this.props.location.search);
    const facilityTypeToCall: any = (queryValues.type) ? queryValues.type : facilityTypes.ALL;

    return facilityTypeToCall;
  }

  async componentDidMount() {
    const {
      countryStore,
      facilityStore,
      authStore,
    } = this.props;

    await countryStore.getUserManagedCountries();

    const facilityTypeToCall = this.getQueryParam();

    this.setState({
      facilityType: facilityTypeToCall,
    })

    facilityStore.getFacilities(countryStore.managedCountries, facilityTypeToCall, undefined , languageCodes.english);
  }

  async componentDidUpdate(prevProps: IProps) {
    try {
      const {
        countryStore,
        facilityStore,
      } = this.props;
      const {
        type: prevType,
      } = queryString.parse(prevProps.location.search);
      const {
        type: newType,
      } = queryString.parse(this.props.location.search);

      if(prevType !== newType) {
        this.setState({
          facilityType: newType,
        });
        facilityStore.getFacilities(countryStore.managedCountries, (newType as any), undefined , languageCodes.english);
      }
    } catch (error) {
      throw error;
    }
  }
}

export default Facilities;
